import { ApplicationState } from '../types';

export const userSearchTermSelector = (state: ApplicationState) =>
  state.core.search.userSearch;

export const searchHistorySelector = (state: ApplicationState) =>
  state.core.search.searchHistory;
